const footerDe = {
	company: 'Grameen Bazar',
	description: 'Bangladeschs größter Online-Marktplatz. Finden Sie alles für den Alltag.',
	links: {
		company: 'Unternehmen',
		business: 'Geschäft',
		support: 'Support',
		about: 'Über uns',
		career: 'Karriere',
		contact: 'Kontakt',
		help: 'Hilfe',
		becomeSeller: 'Verkäufer werden',
		businessAccount: 'Geschäftskonto',
		marketplacePolicy: 'Marktplatz-Richtlinie',
		deliveryPolicy: 'Lieferbedingungen',
		returnPolicy: 'Rückgabebedingungen',
		privacyPolicy: 'Datenschutz',
	},
	contact: {
		heading: 'Kontakt',
		address: 'Haus Nr. 123, Straße 45, Banani, Dhaka-1213',
	},
	copyright: (year) => `© ${year} Grameen Bazar. Alle Rechte vorbehalten.`,
};

export default footerDe;


